import NwReactCollapse from './nw-react-collapse';

export default NwReactCollapse;
